import { render, staticRenderFns } from "./ModalEditStudentData.vue?vue&type=template&id=315abd11&scoped=true&lang=pug&"
import script from "./ModalEditStudentData.vue?vue&type=script&lang=ts&"
export * from "./ModalEditStudentData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315abd11",
  null
  
)

export default component.exports